'use client'

export { GenericErrorBoundaryFallback as default } from '@/components/error/fallback'
